<template>
  <scroll-bar>
    <div class="logoWrapper">
      <img v-if="userInfo.platform_logo" width="52" height="25" :src="userInfo.platform_logo" alt="">
      <div class="logoTitle">{{userInfo.platform_name}}</div>
    </div>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#252733"
      text-color="#bfcbd9"
      active-text-color="#3670FF"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers',
      'userInfo'
    ]),
    routes() {
      // return this.$router.options.routes
      // console.log(555,this.userInfo)
      let routers = this.routers
      routers.forEach((items)=>{
        if (items.children&&items.children.length>0) {
          items.children.forEach((item)=>{
            let name = item.name
            item.meta.lang=this.$t(`routers.${name}`)
          })
        }

      })
      return routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .logoWrapper{
     text-align: center;
     padding: 20px 10px;
    .logoTitle{
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 50px;
      text-align: center;
    }
  }


</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue